export default {
  id: 'categories',
  title: 'Kategorije',
  icon: 'mdi-tag-multiple',
  show: true,
  order: 7, // Pozicija glavne kategorije u meniju
  children: [
    {
      id: 'categories-overview',
      title: 'Što su kategorije?',
      icon: 'mdi-information',
      show: true,
      order: 1, // Pozicija podkategorije unutar glavne kategorije
      content: () => `
        <h2 id="what-are-categories">Što su kategorije?</h2>
        <p>
          Kategorije su sustav organizacije artikala koji omogućava logičko grupiranje srodnih proizvoda ili usluga.
          Korištenje kategorija olakšava pretraživanje artikala, kreiranje izvještaja i analizu prodaje po vrstama proizvoda.
        </p>

        <h3 class="mt-4">Zašto koristiti kategorije?</h3>

        <table class="info-table">
          <thead>
            <tr>
              <th>Prednost</th>
              <th>Opis</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Organizacija</strong></td>
              <td>Lakše pronalaženje artikala u sustavu</td>
            </tr>
            <tr>
              <td><strong>Navigacija na blagajni</strong></td>
              <td>Blagajnik brže pronalazi proizvode tokom prodaje</td>
            </tr>
            <tr>
              <td><strong>Izvještaji</strong></td>
              <td>Analiza prodaje po kategorijama proizvoda</td>
            </tr>
            <tr>
              <td><strong>Vizualizacija</strong></td>
              <td>Prikazivanje artikala grupiranih po kategorijama na POS sučelju</td>
            </tr>
            <tr>
              <td><strong>Upravljanje cjenicima</strong></td>
              <td>Lakša izmjena cijena za cijelu kategoriju</td>
            </tr>
          </tbody>
        </table>

        <h3 class="mt-4">Primjeri kategorija</h3>

        <h4 class="mt-3">Trgovina</h4>
        <ul>
          <li><strong>Pića</strong> - Sokovi, Gazirana pića, Voda, Kava</li>
          <li><strong>Hrana</strong> - Mliječni proizvodi, Kruh, Konzerve, Slatkiši</li>
          <li><strong>Higijena</strong> - Sapuni, Šamponi, Paste za zube</li>
          <li><strong>Ostalo</strong> - Novine, Upaljači, Baterije</li>
        </ul>

        <h4 class="mt-3">Restoran</h4>
        <ul>
          <li><strong>Predjela</strong> - Juhe, Salate, Zakuske</li>
          <li><strong>Glavna jela</strong> - Meso, Riba, Tjestenina, Pizza</li>
          <li><strong>Deserti</strong> - Torte, Sladoledi, Kolači</li>
          <li><strong>Pića</strong> - Sokovi, Vino, Pivo, Kava</li>
        </ul>

        <h4 class="mt-3">Uslužna djelatnost</h4>
        <ul>
          <li><strong>Frizura</strong> - Šišanje, Feniranje, Pranje</li>
          <li><strong>Bojanje</strong> - Farbanje, Pramenovi, Balayage</li>
          <li><strong>Njega</strong> - Tretmani, Maske, Paketi</li>
        </ul>

        <h3 class="mt-4">Hijerarhija kategorija</h3>

        <p>
          Sustav podržava hijerarhijske kategorije, što znači da kategorije mogu imati podkategorije (neograničena razina):
        </p>

        <div class="info-box">
          <i class="mdi mdi-information" style="color: #3989C9; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Primjer hijerarhije:</strong><br><br>
            <strong>Pića</strong> (glavna kategorija)<br>
            ├── <strong>Sokovi</strong> (podkategorija)<br>
            │   ├── Prirodni sokovi<br>
            │   └── Gazirani sokovi<br>
            ├── <strong>Kava</strong><br>
            │   ├── Espresso<br>
            │   ├── Cappuccino<br>
            │   └── Latte<br>
            └── <strong>Alkoholna pića</strong><br>
            &nbsp;&nbsp;&nbsp;&nbsp;├── Vino<br>
            &nbsp;&nbsp;&nbsp;&nbsp;├── Pivo<br>
            &nbsp;&nbsp;&nbsp;&nbsp;└── Žestoka pića
          </div>
        </div>

        <h3 class="mt-4">Karakteristike kategorije</h3>

        <p>Svaka kategorija može imati sljedeće atribute:</p>

        <ul>
          <li><strong>Naziv</strong> - Jedinstveni naziv kategorije (npr. "Pića", "Glavna jela")</li>
          <li><strong>Boja</strong> - Vizualna identifikacija na POS sučelju</li>
          <li><strong>Ikona</strong> - Material Design ikona za lakše prepoznavanje</li>
          <li><strong>Redoslijed prikaza</strong> - Sortiranje kategorija na blagajni</li>
          <li><strong>Nadređena kategorija</strong> - Definiranje hijerarhije (parent category)</li>
          <li><strong>Status</strong> - Aktivna ili neaktivna</li>
        </ul>

        <h3 class="mt-4">Pristup kategorijama</h3>

        <ol>
          <li>Iz glavnog izbornika idite na <strong>"Artikli" → "Kategorije"</strong></li>
          <li>Prikazat će se lista svih kategorija</li>
          <li>Možete pregledati, dodavati, uređivati i brisati kategorije</li>
        </ol>

        <h3 class="mt-4">Rad sa kategorijama</h3>

        <table class="info-table">
          <thead>
            <tr>
              <th>Akcija</th>
              <th>Opis</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Dodavanje kategorije</strong></td>
              <td>Kreirajte novu kategoriju ili podkategoriju</td>
            </tr>
            <tr>
              <td><strong>Uređivanje</strong></td>
              <td>Promijenite naziv, boju, ikonu ili hijerarhiju</td>
            </tr>
            <tr>
              <td><strong>Brisanje</strong></td>
              <td>Obrišite kategoriju (samo ako nema artikala u njoj)</td>
            </tr>
            <tr>
              <td><strong>Sortiranje</strong></td>
              <td>Definirajte redoslijed prikaza kategorija</td>
            </tr>
            <tr>
              <td><strong>Premještanje artikala</strong></td>
              <td>Premjestite artikle iz jedne kategorije u drugu</td>
            </tr>
          </tbody>
        </table>

        <div class="warning-box">
          <i class="mdi mdi-alert" style="color: #FF9800; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Napomena:</strong> Kategoriju koja sadrži artikle nije moguće obrisati.
            Prvo morate premjestiti ili obrisati sve artikle iz te kategorije.
          </div>
        </div>

        <h3 class="mt-4">Prikaz na blagajni</h3>

        <p>
          Na POS sučelju (blagajni), kategorije se prikazuju kao gumbovi ili liste koje omogućavaju brzu navigaciju:
        </p>

        <ul>
          <li>Kliknite na kategoriju da vidite artikle u njoj</li>
          <li>Kategorije su obojene prema definiranoj boji</li>
          <li>Prikazuju se ikone za vizualno prepoznavanje</li>
          <li>Hijerarhija omogućava dubinsku navigaciju (kategorija → podkategorija → artikl)</li>
        </ul>

        <div class="success-box">
          <i class="mdi mdi-lightbulb" style="color: #4CAF50; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Savjet:</strong> Planirajte kategorije prije unosa artikala.
            Dobro organizirana struktura kategorija značajno ubrzava rad na blagajni.
          </div>
        </div>

        <h3 class="mt-4">Često postavljana pitanja</h3>

        <h4 class="mt-3">Koliko razina kategorija mogu imati?</h4>
        <p>
          Sustav podržava neograničen broj razina kategorija (hijerarhija).
          Međutim, preporučuje se maksimalno 3-4 razine za lakšu navigaciju.
        </p>

        <h4 class="mt-3">Može li artikl biti u više kategorija?</h4>
        <p>
          Ne, svaki artikl pripada točno jednoj kategoriji.
          Ako želite artikl učiniti dostupnim na više mjesta, možete koristiti tagove ili oznake.
        </p>

        <h4 class="mt-3">Što ako ne želim koristiti kategorije?</h4>
        <p>
          Kategorije nisu obavezne, ali ih preporučujemo. Možete kreirati jednu opću kategoriju
          (npr. "Svi proizvodi") i sve artikle staviti u nju.
        </p>

        <h4 class="mt-3">Mogu li promijeniti kategoriju artiklu naknadno?</h4>
        <p>
          Da, možete u bilo kojem trenutku promijeniti kategoriju artiklu kroz uređivanje artikla
          ili grupnom akcijom za više artikala odjednom.
        </p>
      `
    },
    {
      id: 'categories-add',
      title: 'Dodavanje kategorije',
      icon: 'mdi-plus',
      show: true,
      order: 2,
      content: () => `
        <h2 id="add-category">Dodavanje kategorije</h2>
        <p>
          Kategorije služe za organizaciju artikala u grupe. Dobro organizirane kategorije
          olakšavaju pronalaženje artikala i upravljanje cjenikom.
        </p>

        <h3 class="mt-4">Korak po korak</h3>

        <h4 class="mt-3">1. Otvaranje forme</h4>
        <ol>
          <li>Idite na <strong>"Artikli" → "Kategorije"</strong></li>
          <li>Kliknite <strong>"+ Dodaj kategoriju"</strong></li>
        </ol>

        <h4 class="mt-3">2. Osnovni podaci</h4>
        <ul>
          <li><strong>Naziv *</strong> - Naziv kategorije (npr. "Pića", "Hrana", "Ugostiteljstvo")</li>
          <li><strong>Šifra</strong> - Jedinstvena šifra (opciono, sustav automatski generira)</li>
          <li><strong>Opis</strong> - Kratki opis kategorije</li>
        </ul>

        <h4 class="mt-3">3. Nadkategorija (opcionalno)</h4>
        <p>Ako želite kreirati podkategoriju:</p>
        <ul>
          <li>Odaberite <strong>"Nadkategorija"</strong> iz dropdown liste</li>
          <li>Primjer: Kategorija "Sokovi" može biti podkategorija od "Pića"</li>
        </ul>

        <div class="info-box">
          <i class="mdi mdi-information" style="color: #3989C9; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Hijerarhija:</strong> Možete kreirati do 3 razine kategorija (npr. Pića → Bezalkoholna → Sokovi).
          </div>
        </div>

        <h4 class="mt-3">4. Ikona i boja (opcionalno)</h4>
        <ul>
          <li><strong>Ikona</strong> - Odaberite ikonu iz Material Design Icons biblioteke</li>
          <li><strong>Boja</strong> - Odaberite boju za lakše prepoznavanje na blagajni</li>
        </ul>

        <h4 class="mt-3">5. Spremanje</h4>
        <ol>
          <li>Provjerite jesu li podaci ispravni</li>
          <li>Kliknite <strong>"Spremi"</strong></li>
          <li>Kategorija je sada dostupna pri dodavanju artikala</li>
        </ol>

        <div class="success-box">
          <i class="mdi mdi-lightbulb" style="color: #4CAF50; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Savjet:</strong> Planirajte strukturu kategorija unaprijed. Kasnije premještanje artikala između kategorija može biti vremenski zahtjevno.
          </div>
        </div>

        <h3 class="mt-4">Primjeri kategorija</h3>
        <h4 class="mt-3">Za trgovinu:</h4>
        <ul>
          <li>Hrana → Voće i povrće</li>
          <li>Pića → Alkoholna → Vina</li>
          <li>Pića → Bezalkoholna → Sokovi</li>
          <li>Higijena i kozmetika</li>
        </ul>

        <h4 class="mt-3">Za restoran:</h4>
        <ul>
          <li>Jela → Predjela</li>
          <li>Jela → Glavna jela → Riba</li>
          <li>Jela → Glavna jela → Meso</li>
          <li>Pića → Vina → Bijela vina</li>
          <li>Deserti</li>
        </ul>

        <h2 id="tips" class="mt-6">Savjeti</h2>
        <ul>
          <li><strong>Jasni nazivi</strong> - Koristite jasne i koncizne nazive</li>
          <li><strong>Logička struktura</strong> - Organizirajte kategorije logički</li>
          <li><strong>Ne previše razina</strong> - Izbjegavajte previše razina hijerarhije (max 3)</li>
        </ul>
      `
    },
    {
      id: 'categories-hierarchy',
      title: 'Hijerarhija kategorija',
      icon: 'mdi-file-tree',
      show: true,
      order: 3,
      content: () => `
        <h2 id="categories-hierarchy">Hijerarhija kategorija</h2>
        <p>
          Hijerarhijska organizacija kategorija omogućava stvaranje složene strukture kategorija i podkategorija.
          Ova funkcionalnost pomaže u logičkoj organizaciji artikala i olakšava navigaciju, posebno kada imate veliki broj proizvoda.
        </p>

        <h3 class="mt-4">Što je hijerarhija kategorija?</h3>

        <p>
          Hijerarhija kategorija znači da kategorije mogu imati:
        </p>
        <ul>
          <li><strong>Nadređenu kategoriju</strong> (parent) - Kategorija razine iznad</li>
          <li><strong>Podkategorije</strong> (children) - Kategorije razine ispod</li>
          <li><strong>Neograničene razine</strong> - Možete kreirati proizvoljnu dubinu hijerarhije</li>
        </ul>

        <h3 class="mt-4">Primjeri hijerarhije</h3>

        <h4 class="mt-3">Primjer 1: Trgovina prehrambenim proizvodima</h4>

        <div class="info-box">
          <i class="mdi mdi-information" style="color: #3989C9; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Hrana</strong> (glavna kategorija)<br>
            ├── <strong>Mliječni proizvodi</strong><br>
            │   ├── Mlijeko<br>
            │   ├── Jogurt<br>
            │   │   ├── Voćni jogurt<br>
            │   │   └── Prirodni jogurt<br>
            │   ├── Sir<br>
            │   └── Maslac<br>
            ├── <strong>Mesni proizvodi</strong><br>
            │   ├── Svinjetina<br>
            │   ├── Govedina<br>
            │   ├── Perad<br>
            │   └── Kobasice<br>
            └── <strong>Pekarski proizvodi</strong><br>
            &nbsp;&nbsp;&nbsp;&nbsp;├── Kruh<br>
            &nbsp;&nbsp;&nbsp;&nbsp;├── Pecivo<br>
            &nbsp;&nbsp;&nbsp;&nbsp;└── Torte
          </div>
        </div>

        <h4 class="mt-3">Primjer 2: Restoran</h4>

        <div class="info-box">
          <i class="mdi mdi-information" style="color: #3989C9; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Meni</strong> (glavna kategorija)<br>
            ├── <strong>Predjela</strong><br>
            │   ├── Hladna predjela<br>
            │   │   ├── Salate<br>
            │   │   └── Carpaccio<br>
            │   └── Topla predjela<br>
            │   &nbsp;&nbsp;&nbsp;&nbsp;├── Juhe<br>
            │   &nbsp;&nbsp;&nbsp;&nbsp;└── Fritule<br>
            ├── <strong>Glavna jela</strong><br>
            │   ├── Meso<br>
            │   │   ├── Odresci<br>
            │   │   ├── Pečenje<br>
            │   │   └── Gulaš<br>
            │   ├── Riba<br>
            │   │   ├── Bijela riba<br>
            │   │   └── Plava riba<br>
            │   └── Vegetarijansko<br>
            │   &nbsp;&nbsp;&nbsp;&nbsp;├── Tjestenina<br>
            │   &nbsp;&nbsp;&nbsp;&nbsp;└── Rizoto<br>
            └── <strong>Deserti</strong><br>
            &nbsp;&nbsp;&nbsp;&nbsp;├── Sladoledi<br>
            &nbsp;&nbsp;&nbsp;&nbsp;└── Torte
          </div>
        </div>

        <h3 class="mt-4">Kreiranje hijerarhije</h3>

        <h4 class="mt-3">1. Kreiranje glavne kategorije</h4>
        <ol>
          <li>Idite na <strong>"Artikli" → "Kategorije"</strong></li>
          <li>Kliknite <strong>"+ Dodaj kategoriju"</strong></li>
          <li>Unesite naziv (npr. "Pića")</li>
          <li><strong>Ne odabirete</strong> nadređenu kategoriju</li>
          <li>Spremite kategoriju</li>
        </ol>

        <h4 class="mt-3">2. Kreiranje podkategorije</h4>
        <ol>
          <li>Kliknite <strong>"+ Dodaj kategoriju"</strong></li>
          <li>Unesite naziv podkategorije (npr. "Sokovi")</li>
          <li><strong>Odaberite nadređenu kategoriju</strong> (npr. "Pića")</li>
          <li>Spremite podkategoriju</li>
        </ol>

        <h4 class="mt-3">3. Kreiranje pod-podkategorije</h4>
        <ol>
          <li>Kliknite <strong>"+ Dodaj kategoriju"</strong></li>
          <li>Unesite naziv (npr. "Prirodni sokovi")</li>
          <li><strong>Odaberite nadređenu kategoriju</strong> "Sokovi"</li>
          <li>Spremite</li>
        </ol>

        <div class="success-box">
          <i class="mdi mdi-lightbulb" style="color: #4CAF50; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Savjet:</strong> Planirajte hijerarhiju unaprijed na papiru ili u Excel-u.
            Tako ćete lakše organizirati sve kategorije prije unosa u sustav.
          </div>
        </div>

        <h3 class="mt-4">Prikaz hijerarhije</h3>

        <table class="info-table">
          <thead>
            <tr>
              <th>Način prikaza</th>
              <th>Opis</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Lista s uvlakom</strong></td>
              <td>Kategorije prikazane s uvlakama koje pokazuju razinu</td>
            </tr>
            <tr>
              <td><strong>Tree view</strong></td>
              <td>Grafički prikaz stabla kategorija s mogućnošću expand/collapse</td>
            </tr>
            <tr>
              <td><strong>Breadcrumbs</strong></td>
              <td>Prikaz putanje: Pića → Sokovi → Prirodni sokovi</td>
            </tr>
          </tbody>
        </table>

        <h3 class="mt-4">Rad s hijerarhijom</h3>

        <h4 class="mt-3">Premještanje kategorije u hijerarhiji</h4>
        <ol>
          <li>Odaberite kategoriju koju želite premjestiti</li>
          <li>Kliknite <i class="mdi mdi-pencil"></i> <strong>"Uredi"</strong></li>
          <li>Promijenite <strong>"Nadređenu kategoriju"</strong></li>
          <li>Spremite promjene</li>
        </ol>

        <div class="warning-box">
          <i class="mdi mdi-alert" style="color: #FF9800; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Napomena:</strong> Kada premještate kategoriju, svi njeni artikli i podkategorije
            se automatski premještaju s njom.
          </div>
        </div>

        <h4 class="mt-3">Brisanje kategorije s podkategorijama</h4>
        <p>Opcije prilikom brisanja:</p>
        <ul>
          <li><strong>Obriši sve</strong> - Briše kategoriju i sve podkategorije (samo ako su prazne)</li>
          <li><strong>Premjesti gore</strong> - Podkategorije se premještaju jednu razinu gore</li>
          <li><strong>Prebaci u drugu kategoriju</strong> - Odaberite novu nadređenu kategoriju</li>
        </ul>

        <h3 class="mt-4">Navigacija na blagajni</h3>

        <p>
          Hijerarhijska navigacija na POS sučelju omogućava brzo pronalaženje artikala:
        </p>

        <ol>
          <li><strong>Korak 1:</strong> Prikazuju se glavne kategorije (npr. "Pića", "Hrana")</li>
          <li><strong>Korak 2:</strong> Odaberite glavnu kategoriju → prikazuju se podkategorije</li>
          <li><strong>Korak 3:</strong> Odaberite podkategoriju → prikazuju se artikli</li>
          <li><strong>Povratak:</strong> Kliknite "Natrag" ili breadcrumb za povratak</li>
        </ol>

        <h3 class="mt-4">Najbolje prakse</h3>

        <table class="info-table">
          <thead>
            <tr>
              <th>Pravilo</th>
              <th>Preporuka</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Dubina hijerarhije</strong></td>
              <td>Maksimalno 3-4 razine za lakšu navigaciju</td>
            </tr>
            <tr>
              <td><strong>Broj podkategorija</strong></td>
              <td>5-10 podkategorija po nadređenoj kategoriji</td>
            </tr>
            <tr>
              <td><strong>Nazivi kategorija</strong></td>
              <td>Kratki, jasni i deskriptivni nazivi</td>
            </tr>
            <tr>
              <td><strong>Logička organizacija</strong></td>
              <td>Grupišite slične proizvode zajedno</td>
            </tr>
            <tr>
              <td><strong>Boje</strong></td>
              <td>Koristite iste boje za povezane kategorije</td>
            </tr>
          </tbody>
        </table>

        <h3 class="mt-4">Često postavljana pitanja</h3>

        <h4 class="mt-3">Koliko razina hijerarhije mogu imati?</h4>
        <p>
          Tehnički nema ograničenja, ali preporučuje se maksimalno 3-4 razine.
          Previše razina otežava navigaciju i zbunjuje korisnike.
        </p>

        <h4 class="mt-3">Mogu li kategoriju pretvoriti u podkategoriju?</h4>
        <p>
          Da, jednostavno uredite kategoriju i odaberite nadređenu kategoriju.
          Sustav će automatski ažurirati hijerarhiju.
        </p>

        <h4 class="mt-3">Što se dešava s artiklima ako obrišem kategoriju?</h4>
        <p>
          Kategoriju s artiklima ne možete obrisati. Prvo morate premjestiti artikle u drugu kategoriju
          ili ih obrisati.
        </p>

        <h4 class="mt-3">Može li podkategorija imati artikle i podkategorije?</h4>
        <p>
          Da, svaka kategorija može istovremeno imati artikle i podkategorije.
          Na primjer, "Pića" može imati artikle i podkategorije "Sokovi", "Kava", itd.
        </p>

        <h4 class="mt-3">Kako preimenovati kategoriju?</h4>
        <p>
          Kliknite <i class="mdi mdi-pencil"></i> "Uredi" kraj kategorije, promijenite naziv i spremite.
          Promjena naziva neće utjecati na hijerarhiju niti na artikle.
        </p>
      `
    }
  ]
}
